<template>
  <div class="regist">
    <p>2020年12月をもちまして、サイトをリニューアルいたしました。</p>
    <p>
      旧サイトから引き続き会員限定機能をご利用いただくにはパスワー
      ドの再設定が必要です。<br />
      誠にお手数ですが下記のお手続きをお願いいたします。
    </p>
    <p>■新サイトへの引継ぎ方法</p>
    <ol>
      <li>
        ①以下、ご登録時のメールアドレスをご入力いただき、「送信する」ボタンを押してください。<br />
        ※利用規約が変更になっておりますので、合わせてご確認ください。
      </li>
      <li>
        ②入力したメールアドレス宛に仮登録メールが届きます。<br />
        ※ドメイン設定により、受信が拒否されている場合があります。<br />「info@mynavi.jp」からのメールが受信できるようにご設定ください。
      </li>
      <li>
        ③仮登録メールに記載されたリンクをクリックし、画面の案内に従って引継ぎを完了させてください。
      </li>
    </ol>
    <form>
      <FormInputField
        name="email_confirmation"
        label="メールアドレス"
        patternLabel="半角英数"
        placeholder="例：abd@example.com"
        v-model="state.email"
        :error="state.isError"
        :error-message="state.errorMessage"
        @change-message="changeMessage('email', $event)"
        req
      />

      <CheckboxButton
        name="agree"
        label="規約等を確認の上、同意する場合はチェックしてください。"
        id="agree"
        :error="state.isErrorAgree"
        value="1"
        :checked="agree_flg"
        @call-input-change="changeFlg('agree_flg', $event)"
      />

      <ul>
        <li>
          <a href="/privacy_policy" target="_blank">プライバシーポリシー</a>
        </li>
        <li><a href="/terms" target="_blank">サイト利用規約</a></li>
      </ul>

      <input type="hidden" name="_token" :value="csrf" />

      <GoalButtons>
        <Button
          label="仮登録メールを送信する"
          :handleClick="sendConfirm"
          primary
        />
      </GoalButtons>
    </form>
  </div>
</template>

<script lang="ts">
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import FormInputField from '@/components/block/FormInputField.vue'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import Button from '@/components/elements/Button.vue'
import axios from 'axios'

export default {
  components: {
    FormInputField,
    CheckboxButton,
    GoalButtons,
    Button
  },

  setup() {
    const state = reactive<{
      email: string
      isError: boolean
      errorMessage: string
      isErrorAgree: boolean
    }>({
      email: '',
      isError: false,
      errorMessage: '',
      isErrorAgree: false
    })

    const agree_flg = ref(false)

    const changeMessage = (name: string, value: string) => {
      state.email = value
    }

    const changeFlg = (target: string, ev: any) => {
      agree_flg.value = ev.checked
    }

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )
    const router = useRouter()

    const sendConfirm = async () => {
      try {
        if (!agree_flg.value) {
          alert('入力に誤りがあります')
          state.isErrorAgree = true
          return true
        }

        await axios.post('/api/v1/start_use/email', {
          email: state.email,
          csrf: csrf
        })
        router.push('/procedure/send/')
      } catch (errors) {
        alert('入力に誤りがあります')

        const errorInfo = errors.response.data
        Object.keys(errorInfo).forEach((key) => {
          state.isError = true
          state.errorMessage = errorInfo[key].join()
        })
      }
    }
    return {
      state,
      sendConfirm,
      changeMessage,
      agree_flg,
      changeFlg,
      csrf
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

p:not(:last-of-type) {
  margin-bottom: 1em;
}
ol {
  margin-bottom: 2em;
  li {
    margin-bottom: 1em;
  }
}
.formField {
  margin-bottom: 2em;
}
.checkboxButton {
  margin-bottom: 0.5em;
}
ul {
  display: flex;
  li:first-child {
    margin-right: 1em;
  }
  a {
    color: var.$color-main-text;
  }
}
</style>
